import { render, staticRenderFns } from "./GenericItem.vue?vue&type=template&id=4a03450f&scoped=true"
import script from "./GenericItem.vue?vue&type=script&lang=ts"
export * from "./GenericItem.vue?vue&type=script&lang=ts"
import style0 from "./GenericItem.vue?vue&type=style&index=0&id=4a03450f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03450f",
  null
  
)

export default component.exports